var loaderStateLoading = 'loaderStateLoading';
var loaderStateSuccess = 'loaderStateSuccess';
var loaderStateFailure = 'loaderStateFailure';